export default __webpack_public_path__ + "static/media/addCircle.4baba61b.svg";